import { ErrorToast } from "../components/toastify";
import { AxiosGetMethod } from "../helpers/customAxios";
import HandleLogout from "./handleLogout";

export async function getEventAutomationReport(params = {}) {
  const query = [];
  if (params.startDate) query.push(`start_date=${params.startDate}`);
  if (params.endDate) query.push(`end_date=${params.endDate}`);
  if (params.searchValue) {
    query.push(`search_value=${encodeURIComponent(params.searchValue)}`);
  }
  if (params.page) query.push(`page=${params.page}`);
  if (params.perPage) query.push(`per_page=${params.perPage}`);

  const response = await AxiosGetMethod(
    `org/event/automation-report?${query.join("&")}`
  );

  if (response?.status === 200) {
    return response.data?.data || { items: [], pagination: null, summary: null };
  }

  if (response?.status === 401) HandleLogout();
  ErrorToast("Unable to load automation report.");
  return { items: [], pagination: null, summary: null };
}

export async function getEventAutomationReportDetail(eventId) {
  const response = await AxiosGetMethod(
    `org/event/automation-report-detail?event_id=${eventId}`
  );

  if (response?.status === 200) {
    return response.data?.data || null;
  }

  if (response?.status === 401) HandleLogout();
  ErrorToast("Unable to load automation report detail.");
  return null;
}
